import React from "react"

export default function Acknowledgements() {
  return (
    <>
      <p className="text-sm leading-5 text-left text-gray-500">
      The Cornell apple carbohydrate thinning model was authored by Terence Robinson and Alan Lakso, School of Integrated Plant Science, Horticulture Section, Cornell University.
      </p>
    </>
  )
}
